// extracted by mini-css-extract-plugin
export default {"formTitle":"styles_formTitle__z8lv7"};